import { LoadingBtnComponent } from "@/app/components/loading-btn"
import { Button } from "@/app/components/ui/button"
import { useToast } from "@/app/components/ui/use-toast"
import { OPEN_MODAL } from "@/app/configs"
import { AppContext } from "@/app/context"
import useGAEventsTracker from "@/app/hooks/useGAEventsTracker"
import TopupService from "@/app/services/services/TopupService"
import {
  IApplyVoucherTopup,
  IBodyTopup,
  IBodyTopupGlobal,
  IPackageMethod,
  ITopupSelectedData
} from "@interfaces/ITopup"
import { Trans, useTranslation } from "next-i18next"
import { useRouter } from "next/router"
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState
} from "react"
import { VoucherComponent } from "./voucher/VoucherComponent"

interface TopupOrderInfoMobileProps {
  selectedData: ITopupSelectedData
  setSelectedData: Dispatch<SetStateAction<ITopupSelectedData>>
  loadingCallingMethod: boolean
  renderMethods: IPackageMethod[]
  setVisible: (param: any) => void
  setErrorCode: (errorCode: string) => void
  errorCode: string
  applyVoucher: IApplyVoucherTopup | null
  loadingVoucher: boolean
  checkVoucher: (value: string) => void
  setApplyVoucher: (applyVoucher: any) => void
}
export const TopupOrderInfoMobile: React.FC<TopupOrderInfoMobileProps> = ({
  selectedData,
  setSelectedData,
  loadingCallingMethod,
  renderMethods,
  setVisible,
  setErrorCode,
  errorCode,
  applyVoucher,
  loadingVoucher,
  checkVoucher,
  setApplyVoucher
}) => {
  const { t } = useTranslation()
  const router = useRouter()
  const { toast } = useToast()
  const {
    userInfo: userProfile,
    themeApp,
    setOpenModal
  } = useContext(AppContext)
  const [checked, setChecked] = useState(false)
  const [loading, setLoading] = useState<any>(false)
  const [show, setShow] = useState(false)
  const GAEventsTracker = useGAEventsTracker("Store_TopupGame")
  const handleSubmitTopup = async () => {
    if (userProfile?.id) {
      setLoading(true)
      GAEventsTracker(
        "Store_Bt_Buy",
        "Thanh toan nap game",
        selectedData?.selectMethod?.item?.amount
      )
      try {
        if (
          !!selectedData?.country_code &&
          selectedData?.country_code !== "VN"
        ) {
          let body: IBodyTopupGlobal = {
            slug_name: String(router?.query?.slug_name),
            package_id: selectedData?.selectPackage.package_id,
            user_id: selectedData?.selectUser?.user_id,
            server_id: selectedData?.selectServer?.server_id,
            role_id: selectedData?.selectRole?.role_id,
            country_code: selectedData?.country_code
          }

          if (selectedData?.selectPlatform?.platform_id) {
            body = {
              ...body,
              platform: selectedData?.selectPlatform?.platform_id
            }
          }

          const res = await TopupService.submitDoTopupGlobal(body)
          if (res?.data?.errorCode === 0) {
            router?.push(res?.data?.data?.url)
          } else if (res?.data.errorCode === 15) {
            setVisible(true)
          } else {
            toast({ title: res?.data?.message, variant: "error" })
          }
        } else {
          if (selectedData?.selectMethod?.method === "appota_card") {
            const query = {
              method: selectedData?.selectMethod?.method,
              amount: selectedData?.selectMethod?.item?.amount,
              v3_id: selectedData?.selectPackage?.v3_id,
              v3_title: selectedData?.selectPackage?.v3_title,
              package_id: selectedData?.selectMethod?.item?.package_id,
              user_id: selectedData?.selectUser?.user_id,
              server_id: selectedData?.selectServer?.server_id,
              server_name: selectedData?.selectServer?.server_name,
              role_id: selectedData?.selectRole?.role_id,
              role_name: selectedData?.selectRole?.role_name,
              platform: selectedData?.selectPlatform?.platform_id,
              platform_name: selectedData?.selectPlatform?.platform_name
            }

            router.push({
              pathname: "/topup/[slug_name]/input-card",
              query: { slug_name: router?.query?.slug_name, ...query }
            })
          } else {
            let body: IBodyTopup = {
              slug_name: String(router?.query?.slug_name),
              method: selectedData?.selectMethod?.method,
              v3_id: selectedData?.selectPackage?.v3_id,
              package_id: selectedData?.selectMethod?.item?.package_id,
              user_id: selectedData?.selectUser?.user_id,
              server_id: selectedData?.selectServer?.server_id,
              role_id: selectedData?.selectRole?.role_id,
              voucher_code: selectedData?.voucher_code
            }

            if (selectedData?.selectPlatform?.platform_id) {
              body = {
                ...body,
                platform: selectedData?.selectPlatform?.platform_id
              }
            }
            const res = await TopupService.submitDoTopup(body)
            if (res?.data?.errorCode === 0) {
              if (res?.data?.data?.url.includes("la-invoice")) {
                const _url = res?.data?.data?.url.split("?transaction_id=")
                router?.push(_url.join("/"))
              } else {
                router?.push(res?.data?.data?.url)
              }
            } else if (res?.data.errorCode === 15) {
              setVisible(true)
            } else {
              toast({ title: res?.data?.message, variant: "error" })
            }
          }
        }
      } catch (err: any) {
        if (err.data.errorCode === 15) {
          setVisible(true)
        } else {
          toast({ title: err?.data?.message, variant: "error" })
        }
      } finally {
        setLoading(false)
      }
    } else {
      setOpenModal(OPEN_MODAL.LOGIN_MODAL)
    }
  }

  const disableBtn = () => {
    if (selectedData?.selectPackage?.v3_id) {
      return (
        !userProfile ||
        !selectedData?.selectMethod?.item?.amount ||
        !selectedData?.selectPackage?.v3_id ||
        !selectedData?.selectRole?.role_id ||
        !selectedData?.selectUser?.user_id ||
        loadingCallingMethod ||
        (show && !checked)
      )
    }

    if (selectedData?.selectPackage?.package_id) {
      return (
        !userProfile ||
        !selectedData?.selectPackage?.package_id ||
        !selectedData?.selectRole?.role_id ||
        !selectedData?.selectUser?.user_id ||
        !selectedData?.country_code ||
        (show && !checked)
      )
    }

    return true
  }

  const onChangeSelectMethod = (item: IPackageMethod) => {
    if (!loading) {
      // GAEventsTracker("Store_Topup_package")
      if (
        item.method !== "gamota_la" ||
        selectedData.selectPackage.v3_amount <= userProfile.total_la
      )
        setSelectedData({
          ...selectedData,
          selectMethod: item
        })
    }
  }

  const totalNumber = applyVoucher?.pay_amount
    ? applyVoucher?.pay_amount
    : selectedData.selectPackage.v3_id
    ? selectedData?.selectMethod?.item?.amount
    : 0

  const renderCheckoutDetail = () => {
    return (
      <>
        <div className="flex flex-col h-full hidden-scroll-bar">
          <div className="flex items-center w-full gap-2 px-[16px]">
            <button
              type="button"
              onClick={() => {
                setShow(false)
              }}
              className="bg-bg-button dark:bg-white/10 rounded-[8px] p-[4px]"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.125 17.4301L7.41997 11.7251C6.74622 11.0513 6.74622 9.94882 7.41997 9.27507L13.125 3.57007"
                  stroke={themeApp === "dark" ? "#FFFFFF" : "#100D28"}
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <span className="Nunito-700 text-[16px] dark:text-main-white flex-1 text-center">
              {t("store.pay")}
            </span>
          </div>
          <div
            className="flex flex-col overflow-auto px-[16px]"
            style={{
              height: "calc(100dvh - 230px)"
            }}
          >
            <div className="flex justify-between gap-[8px] items-center my-[16px] rounded-[12px] p-[8px] pl-[16px] border border-main-01 text-[16px] Nunito-700">
              {selectedData?.selectPackage?.v3_title ||
                selectedData?.selectPackage?.package_title ||
                "--"}
              <p className="bg-bg-02-text-box whitespace-nowrap dark:bg-white/10 px-[12px] py-[4px] rounded-[8px]">
                {selectedData.selectPackage.v3_id &&
                  `${(
                    selectedData?.selectMethod?.item?.amount || 0
                  ).toLocaleString()} đ`}

                {selectedData.selectPackage.package_id &&
                  `${selectedData.selectPackage?.package_amount?.toLocaleString()} ${
                    selectedData.selectPackage?.currency
                  }`}
              </p>
            </div>

            <div className="px-[12px] grid grid-cols-2 gap-[16px]">
              <label className="text-[14px] text-neutral-06 dark:text-neutral-07">
                {t("store.total_amount")}:
              </label>
              <p className="text-[16px] Nunito-600 text-end">
                {selectedData.selectPackage.v3_id &&
                  `${(
                    selectedData?.selectMethod?.item?.amount || 0
                  ).toLocaleString()} đ`}

                {selectedData.selectPackage.package_id &&
                  `${selectedData.selectPackage?.package_amount?.toLocaleString()} ${
                    selectedData.selectPackage?.currency
                  }`}
              </p>
            </div>
            {selectedData?.selectMethod?.method !== "appota_card" &&
              selectedData?.selectMethod?.method !== "va_bank_atm" &&
              selectedData?.selectMethod?.method !== "bank_qrpay" &&
              !(
                !!selectedData?.country_code &&
                selectedData?.country_code !== "VN"
              ) && (
                <VoucherComponent
                  setErrorCode={setErrorCode}
                  errorCode={errorCode}
                  selectedData={selectedData}
                  setSelectedData={setSelectedData}
                  checkVoucher={checkVoucher}
                  loading={loadingVoucher}
                  applyVoucher={applyVoucher}
                  total={
                    selectedData.selectPackage.v3_id
                      ? selectedData?.selectMethod?.item?.amount
                      : 0
                  }
                  setApplyVoucher={setApplyVoucher}
                />
              )}
            {selectedData.selectPackage.v3_id && (
              <>
                <div className="my-[24px] border border-dashed border-neutral-07/10 border-[0.4px] dark:border-white/10"></div>
                <div>
                  <h2 className="text-[14px] Nunito-700 pb-[16px]">
                    {t("store.payment_method")}
                  </h2>
                  <div className="flex flex-col gap-[16px] md:hidden">
                    {!!renderMethods?.length &&
                      renderMethods.map((item, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              onChangeSelectMethod(item)
                            }}
                            className={`${
                              item?.method ===
                              selectedData?.selectMethod?.method
                                ? "border-[1px] px-[24px] border-main-01"
                                : "px-[24px] dark:bg-block-color dark:border-white/10 border-white border-[1px]"
                            }  rounded-[12px] flex items-center h-[54px] bg-white dark:bg-white/10 w-full`}
                          >
                            <img
                              src={item?.icon}
                              className="w-[32px] h-[32px] rounded-[8px] mr-[10px] object-cover border border-black/10 dark:border-white/10"
                            />

                            <div
                              className={`${
                                item.method === "gamota_la" &&
                                selectedData?.selectPackage?.v3_amount >
                                  userProfile?.total_la &&
                                "opacity-60"
                              }`}
                            >
                              <p
                                className={`text-[14px] Nunito-700 leading-[14px] ${
                                  item.method === "gamota_la" &&
                                  "text-[#E8A236]"
                                }`}
                              >
                                {item?.name}
                              </p>
                              {item.method === "gamota_la" && (
                                <p className="text-[#E8A236] text-[12px] Nunito-500">
                                  {t("store.la_number", {
                                    number:
                                      userProfile?.total_la?.toLocaleString()
                                  })}
                                </p>
                              )}
                            </div>
                            {item.method === "gamota_la" &&
                            selectedData?.selectPackage?.v3_amount >
                              userProfile?.total_la ? (
                              <Button
                                variant="main"
                                className="h-[24px] ml-auto text-[12px] Nunito-SemoBold opacity-160"
                                onClick={() => {
                                  router.push("/topup/napla")
                                }}
                              >
                                {t("store.la_invoice")}
                              </Button>
                            ) : (
                              <div className="relative ml-auto group">
                                <p className="mr-0 text-sm text-right text-main-01 Nunito-700">
                                  đ {item?.item?.amount?.toLocaleString()}
                                </p>
                                <p className="mr-0 text-xs text-right text-main-01 Nunito-600">
                                  {item?.item?.value} {item?.item?.currency}
                                </p>
                                {!!selectedData?.hoverDescription && (
                                  <div className="absolute bottom-6 z-10 scale-0 min-w-[300px] max-w-[300px] rounded-2xl Nunito-500 bg-white p-4 transition-all text-sm text-main-text-color border border-input-border-light group-hover:scale-100">
                                    {selectedData?.hoverDescription}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )
                      })}
                  </div>
                </div>
              </>
            )}
          </div>

          <div
            className="mt-auto bg-white dark:bg-bg-header rounded-tl-[16px] rounded-tr-[16px] absolute bottom-0 left-0 right-0 w-full px-[16px] py-[24px]"
            style={{
              boxShadow: "4px 4px 15px 0px rgba(0, 0, 0, 0.04)"
            }}
          >
            {renderCheckout()}
          </div>
        </div>
      </>
    )
  }

  const renderCheckout = () => {
    return (
      <>
        <div className="flex justify-between mb-[8px]">
          <label className="text-[14px] Nunito-700">{t("store.total")}</label>
          <p className="text-[16px] text-main-red-02">
            <span className="Nunito-700">
              {selectedData.selectPackage.v3_id &&
                (show
                  ? totalNumber?.toLocaleString()
                  : (
                      selectedData?.selectMethod?.item?.amount || 0
                    ).toLocaleString())}
              {selectedData.selectPackage.package_id &&
                selectedData.selectPackage?.package_amount?.toLocaleString()}{" "}
              {selectedData.selectPackage.v3_id && "đ"}
              {selectedData.selectPackage.package_id &&
                selectedData.selectPackage?.currency}
            </span>
          </p>
        </div>
        <div className="mt-auto mb-0">
          {show && (
            <div
              className="Nunito-400 text-[12px] pb-2 text-[#A0A2A3] flex items-start cursor-pointer"
              onClick={() => setChecked(!checked)}
            >
              <div className="mr-[10px] mt-1">
                {checked ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    className="w-[16px] h-[16px]"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.5003 1.1665H3.50033C2.21166 1.1665 1.16699 2.21117 1.16699 3.49984V10.4998C1.16699 11.7885 2.21166 12.8332 3.50033 12.8332H10.5003C11.789 12.8332 12.8337 11.7885 12.8337 10.4998V3.49984C12.8337 2.21117 11.789 1.1665 10.5003 1.1665ZM9.679 5.51846C9.82735 5.32773 9.79299 5.05286 9.60226 4.90452C9.41153 4.75617 9.13666 4.79053 8.98832 4.98126L6.6509 7.98651C6.59893 8.05334 6.50116 8.06201 6.43823 8.00537L4.95967 6.67467C4.78007 6.51303 4.50344 6.52759 4.3418 6.70719C4.18017 6.88678 4.19473 7.16341 4.37432 7.32505L5.85289 8.65576C6.29338 9.0522 6.97775 8.99149 7.34159 8.52371L9.679 5.51846Z"
                      fill="#3263E4"
                    />
                  </svg>
                ) : (
                  <div className="w-[16px] h-[16px] border border-neutral-07 rounded-[4px]"></div>
                )}
              </div>
              <p>
                <Trans
                  i18nKey={t("common.agree_to_privacy_policy_02")}
                  className="flex"
                  components={[
                    <span
                      onClick={(e) => {
                        e.preventDefault()
                        window.open("/term-of-services")
                      }}
                      className="text-[#403D53] dark:text-white underline cursor-pointer ml-[1px] Nunito-700"
                      key={0}
                    ></span>,
                    <span
                      onClick={(e) => {
                        e.preventDefault()
                        window.open("/privacy-policy")
                      }}
                      className="text-[#403D53] dark:text-white underline cursor-pointer ml-[1px] Nunito-700"
                      key={1}
                    ></span>
                  ]}
                />
              </p>
            </div>
          )}

          <Button
            loading={loading}
            variant="main"
            disabled={disableBtn()}
            onClick={() => {
              if (show) {
                handleSubmitTopup()
              } else {
                setShow(true)
              }
            }}
            className="w-full"
          >
            {!loading ? t("store.pay") : <LoadingBtnComponent />}
          </Button>
        </div>
      </>
    )
  }

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "scroll"
    }

    return () => {
      document.body.style.overflow = "scroll"
    }
  }, [show])

  return (
    <div
      className={`${
        show
          ? "bg-bg-light dark:bg-bg-02 h-full"
          : "bg-white dark:bg-bg-header px-[16px]"
      } py-[24px]  fixed bottom-0 left-0 right-0 w-full`}
      style={{
        boxShadow: "4px 4px 15px 0px rgba(0, 0, 0, 0.04)",
        zIndex: 50,
        height: show ? "100dvh" : ""
      }}
    >
      {show ? renderCheckoutDetail() : renderCheckout()}
    </div>
  )
}
